/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PackagingType } from '../../models/packaging-type';
import { UpdatePackagingTypeDto } from '../../models/update-packaging-type-dto';

export interface PackagingControllerUpdate$Params {
  id: string;
      body: UpdatePackagingTypeDto
}

export function packagingControllerUpdate(http: HttpClient, rootUrl: string, params: PackagingControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<PackagingType>> {
  const rb = new RequestBuilder(rootUrl, packagingControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PackagingType>;
    })
  );
}

packagingControllerUpdate.PATH = '/packaging-types/{id}';
